
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexOC_Okt6Gb3_dVbF2GXnGH_OSvVXRLhw23L3x7pjqOAIMeta } from "/opt/render/project/src/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93_45LCx9_oSXM_459TDfNxBc4Y_KejfWesdAsx6QQJDZmgxoMeta } from "/opt/render/project/src/pages/[...slug].vue?macro=true";
import { default as _91slug_93N3BHZVxxp9etI_K7FY5WUisJ9xiUEkNiTb270WyoXxIMeta } from "/opt/render/project/src/pages/news/[slug].vue?macro=true";
import { default as _91_46_46_46slug_93H779IZxYJ2IqoeosiNLRkOEmI5RXtIUPCKhi1HVS6qIMeta } from "/opt/render/project/src/pages/alumni/[...slug].vue?macro=true";
import { default as _91slug_93Fr_45TXmGMxCQioaZRVLBz8e8fxY9e262XqR3yAkAfYAEMeta } from "/opt/render/project/src/pages/schuelerblog/[slug].vue?macro=true";
import { default as component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta } from "/opt/render/project/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw } from "/opt/render/project/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/render/project/src/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/opt/render/project/src/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/render/project/src/pages/index.vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    component: () => import("/opt/render/project/src/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/opt/render/project/src/pages/[...slug].vue")
  },
  {
    name: "news-slug___de",
    path: "/de/news/:slug()",
    component: () => import("/opt/render/project/src/pages/news/[slug].vue")
  },
  {
    name: "news-slug___en",
    path: "/en/news/:slug()",
    component: () => import("/opt/render/project/src/pages/news/[slug].vue")
  },
  {
    name: "alumni-slug___de",
    path: "/de/alumni/:slug(.*)*",
    meta: _91_46_46_46slug_93H779IZxYJ2IqoeosiNLRkOEmI5RXtIUPCKhi1HVS6qIMeta || {},
    component: () => import("/opt/render/project/src/pages/alumni/[...slug].vue")
  },
  {
    name: "alumni-slug___en",
    path: "/en/alumni/:slug(.*)*",
    meta: _91_46_46_46slug_93H779IZxYJ2IqoeosiNLRkOEmI5RXtIUPCKhi1HVS6qIMeta || {},
    component: () => import("/opt/render/project/src/pages/alumni/[...slug].vue")
  },
  {
    name: "schuelerblog-slug___de",
    path: "/de/schuelerblog/:slug()",
    component: () => import("/opt/render/project/src/pages/schuelerblog/[slug].vue")
  },
  {
    name: "schuelerblog-slug___en",
    path: "/en/schuelerblog/:slug()",
    component: () => import("/opt/render/project/src/pages/schuelerblog/[slug].vue")
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/newsnewsletter/news",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/alumni",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/alumni/alumni-mitgliederbereich",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/anmeldung",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/anmeldung-schulnetz",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/aufnahme-uebertrittsbedingungen",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/aufnahme-uebertrittsbedingungen/reglemente",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/aufnahme-uebertrittsbedingungen/termine",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/bildungsangebot/infoanlaesse",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/aufnahme-uebertrittsbedingungen/kosten",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/bildungsangebot",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/bildungsangebot/uebersicht",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/bildungsangebot/einsprachige-ausbildung",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/weitere-angebote",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/weitere-angebote/aufgabenbetreuung-und-einzelfoerderung",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/weitere-angebote/musik",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/weitere-angebote/sport",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/weitere-angebote/thaf",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/weitere-angebote/verpflegung-betreuung-ueber-mittag",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/bildungsangebot/zweisprachige-ausbildung",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/standort/",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/service/kontakt",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/standort",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/stellenangebot",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/portraet/ueber-uns",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/team/",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/portraet",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/portraet/ueber-uns",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/portraet/unser-leitbild",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/team",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/bildende-kunst",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/biologie",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/chemie",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/deutsch",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/englisch",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/geographie",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/geschichte-staatskunde",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/informatik",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/latein-griechisch",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/mathematik",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/musik",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/physik",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/religion-philosophie",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/romanistik",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/sport",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/vorbereitungsklassen",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/fachschaften/wirtschaft-recht",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/portraet/geschichte",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/lehrerschaft",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/ueber-das-fgz/traegerschaft",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/about-fgz",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/about-fgz/portrait/about-us",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/about-fgz/team",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/about-fgz/subject-departments/chemistry",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/about-fgz/subject-departments/geography",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/about-fgz/subject-departments/mathematics",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/about-fgz/subject-departments/physics",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/about-fgz/portrait/history",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/about-fgz/governing-body",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/about-fgz/teachers",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/for-interested-parties/conditions-for-transferregulations/regulations",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/for-interested-parties/education-programmes/information-events",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/for-interested-parties/conditions-for-transferregulations/feescosts",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/for-interested-parties",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/for-interested-parties/education-programmes",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/for-interested-parties/education-programmes/overview",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/de/fuer-interessierte/weitere-angebote/student-exchange-programmes",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/for-interested-parties/education-programmes/bilingual-education-programme",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/for-interested-parties/education-programmes/monolingual-education-programme",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/for-interested-parties/registration",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/registration-schulnetz",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/en/about-fgz/vacant-positions",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  },
  {
    name: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8SwMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubH3DntzDZfSy9idE65Ye6f72Boep7V4yhpMSGPPyM8Sw
  }
]